import { Pipe, PipeTransform } from '@angular/core';
import { IconColor } from '@dxo/ng-swift-ui';

@Pipe({
  name: 'getSortIconColor'
})
export class GetSortIconColorPipe implements PipeTransform {
  transform(expression: boolean): IconColor {
    // Transform the value and return
    return expression ? 'blue' : 'gray';
  }
}
